import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CourseService } from '../../Services/course.service';
import Swal from 'sweetalert2'

@Component({
  selector: 'app-course-comment-form',
  template: require('./course-comment-form.component.html'),
  styles: [require('./course-comment-form.component.css')]
})
export class CourseCommentFormComponent implements OnInit {
  course: any={
    extraInfo: ""
  }
  constructor(
    private courseService: CourseService, 
    private route: ActivatedRoute,
    private router: Router, ) {
      route.params.subscribe(p => {
        if (p["id"]) this.course.id = +p["id"];
        else this.course.id = 0;
      });
   }

  ngOnInit( ) {
    this.loadCurrentCourse(this.course.id);
  }

  loadCurrentCourse(id: number){
    this.courseService.getCourse(id).subscribe( (res:any) =>{
      this.course = res      
    })
  }

  updateComment(){
    Swal.fire({
      title: 'Ben je zeker?',
      text: "Bewaren?",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Jep',
      cancelButtonText: 'Nope'
    }).then((result) => {
      if (result.value) {
        this.courseService.updateComment(this.course.id,this.course.extraInfo).subscribe( (res:any)=>{
          if (res.status==200){
            console.log(res.value);
            this.router.navigate(['/courses/list']);
          }else{
            console.log(res);       
          }
        })
      }
    });
  }

  removeComment(){
    Swal.fire({
      title: 'Ben je zeker?',
      text: "Ben je zeker dat je deze informatie wil verwijderen?",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Jep',
      cancelButtonText: 'Nope'
    }).then((result) => {
      if (result.value) {
        this.courseService.updateComment(this.course.id,"").subscribe( (res:any)=>{
          if (res.status==200){
            console.log(res.value);
            this.router.navigate(['/courses/list']);
          }else{
            console.log(res);       
          }
        })
      }
    });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/course-comment-form/course-comment-form.component.ts